import { Box, Typography } from "@mui/material"

const PredictionSummary = ({ title = "Summary", summary = "" }) => {
    return (
        <Box sx={{ mb: 2, ml: 2 }}>
            <Typography
                variant="h6"
                sx={{
                    fontWeight: "bold",
                    mb: 1.5,
                    fontSize: "1.1rem",
                    color: "primary.main",
                }}
            >
                {title}
            </Typography>

            <Typography
                variant="body1"
                sx={{
                    lineHeight: 1.6,
                    mb: 1.5,
                    fontSize: "1rem",
                    whiteSpace: "pre-wrap",
                }}
            >
                {summary}
            </Typography>
        </Box>
    )
}

export default PredictionSummary
